import {
  Card,
  Text,
  Box,
  CardActions,
  Stack,
  TextProps,
  SxProps,
} from '@/theme/index';
import { DataCardLayout } from './DataCardLayout';

export interface DataCardProps {
  children?: React.ReactNode;
  permalink?: string;
  thumbRating?: () => JSX.Element;
  cardStyles?: SxProps;
  titleProps?: TextProps;
  customTitle?: JSX.Element | JSX.Element[];
  buttonProps?: Record<string, unknown>;
  cardBodyWidth?: string;
  customBody?: JSX.Element | JSX.Element[];
  subtitle?: JSX.Element | JSX.Element[];
  testId?: string;
  spacing?: number;
  layoutSpacing?: number;
  layoutStyles?: SxProps;
  boxStyles?: SxProps;
  badge?: JSX.Element;
  tag?: JSX.Element;
  titleTag?: JSX.Element | null;
  id?: string;
  usesFamilyTreeCta?: boolean;
  addedToFamilyTree?: boolean;
}

export function DataCard({
  children,
  thumbRating: ThumbRating,
  cardStyles,
  titleProps = {},
  customTitle,
  buttonProps = {},
  cardBodyWidth,
  customBody,
  subtitle,
  testId,
  spacing = 1.5,
  layoutSpacing,
  layoutStyles,
  boxStyles,
  badge,
  tag,
  titleTag,
  id,
  usesFamilyTreeCta,
  addedToFamilyTree,
  permalink,
}: DataCardProps) {
  const { title, ...restTitleProps } = titleProps;

  const titleBlock = customTitle || (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      {!!title && (
        <Text
          variant="h2"
          color="success"
          sx={{
            marginBottom: 0,
            wordBreak: 'break-all',
            overflowWrap: 'break-word',
          }}
          {...restTitleProps}
        >
          {title}
        </Text>
      )}
      {titleTag}
    </Stack>
  );

  return (
    <Box
      position="relative"
      maxWidth="100%"
      data-testid={testId}
      data-cy={testId}
      borderRadius={0.5}
      sx={boxStyles}
      id={id}
    >
      {tag && <div>{tag}</div>}
      <Card variant="outlined" sx={{ mb: 2.5, padding: 2.5, ...cardStyles }}>
        <Stack spacing={spacing}>
          {badge}
          <DataCardLayout
            buttonProps={buttonProps}
            cardBodyWidth={cardBodyWidth}
            layoutSpacing={layoutSpacing}
            layoutStyles={layoutStyles}
            usesFamilyTreeCta={usesFamilyTreeCta}
            addedToFamilyTree={addedToFamilyTree}
            permalink={permalink}
          >
            {titleBlock}
            {subtitle}
            {children}
          </DataCardLayout>
        </Stack>
        {customBody && <>{customBody}</>}
        {!!ThumbRating && (
          <CardActions>
            <ThumbRating />
          </CardActions>
        )}
      </Card>
    </Box>
  );
}
